(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-bg-ready') === 'true') return;

    var track = root.querySelector('[data-bg-track]');
    var slides = toArray(root.querySelectorAll('[data-bg-slide]'));
    var dotsWrap = root.querySelector('[data-bg-dots]');
    var prev = root.querySelector('[data-bg-prev]');
    var next = root.querySelector('[data-bg-next]');
    var status = root.querySelector('[data-bg-status]');
    if (!track || slides.length === 0) return;

    root.setAttribute('data-bg-ready', 'true');

    var delay = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer = null;
    var hovering = false;
    var hidden = document.hidden;
    var dots = [];
    var mqTablet = window.matchMedia('(max-width: 989px)');
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var controls = root.querySelector('.bg__controls');

    function perView() {
      if (mqMobile.matches) return 1;
      if (mqTablet.matches) return 2;
      return 3;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function updateChrome() {
      var show = maxIndex() > 0;
      if (controls) controls.hidden = !show;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var pages = maxIndex() + 1;
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bg__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Show gallery group ' + (i + 1));
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        (function (page) {
          btn.addEventListener('click', function () {
            go(page);
          });
        })(i);
        dotsWrap.appendChild(btn);
        dots.push(btn);
      }
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (status) {
        status.textContent = 'Slide ' + (index + 1) + ' of ' + (maxIndex() + 1);
      }
    }

    function go(target) {
      index = Math.max(0, Math.min(target, maxIndex()));
      var slide = slides[index];
      if (slide) {
        track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      updateDots();
      restartTimer();
    }

    function nextSlide() {
      go(index >= maxIndex() ? 0 : index + 1);
    }

    function prevSlide() {
      go(index <= 0 ? maxIndex() : index - 1);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplaySetting || designMode || reduceMotion || hovering || hidden || maxIndex() === 0) return;
      timer = setInterval(nextSlide, delay);
    }

    function restartTimer() {
      stopTimer();
      startTimer();
    }

    if (prev) prev.addEventListener('click', prevSlide);
    if (next) next.addEventListener('click', nextSlide);

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stopTimer();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      startTimer();
    });

    document.addEventListener('visibilitychange', function () {
      hidden = document.hidden;
      if (hidden) stopTimer();
      else startTimer();
    });

    function onResize() {
      buildDots();
      updateChrome();
      go(Math.min(index, maxIndex()));
    }

    if (mqTablet.addEventListener) {
      mqTablet.addEventListener('change', onResize);
      mqMobile.addEventListener('change', onResize);
    } else {
      mqTablet.addListener(onResize);
      mqMobile.addListener(onResize);
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var nearest = 0;
        var nearestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (dist < nearestDist) {
            nearestDist = dist;
            nearest = i;
          }
        });
        if (nearest !== index) {
          index = nearest;
          updateDots();
        }
      });
    }, { passive: true });

    buildDots();
    updateChrome();
    updateDots();
    startTimer();
  }

  function boot() {
    toArray(document.querySelectorAll('[data-bg]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-bg]')).forEach(function (el) {
      el.removeAttribute('data-bg-ready');
      init(el);
    });
  });
})();
